import { Theme } from "@mui/material";
import { AbsenceDayPosition } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";
import { bleedByPosition } from "src/utils/Company/Absences/absenceDayPositionStyles";

interface IPickerStylesArgs {
  isRequestDay: boolean;
  isExcludedDay: boolean;
  color?: string;
  bgColor?: string;
  position?: AbsenceDayPosition;
}

// CalendarPreview uses a smaller border-radius than the datepicker
const borderRadiusByPosition: Record<AbsenceDayPosition, string> = {
  [AbsenceDayPosition.SINGLE]: "0.25rem",
  [AbsenceDayPosition.START]: "0.25rem 0 0 0.25rem",
  [AbsenceDayPosition.MIDDLE]: "0",
  [AbsenceDayPosition.END]: "0 0.25rem 0.25rem 0",
};

export const getPickerStyles = ({
  isRequestDay,
  isExcludedDay,
  color,
  bgColor,
  position = AbsenceDayPosition.SINGLE,
}: IPickerStylesArgs) => {
  const defaultColor =
    // eslint-disable-next-line no-nested-ternary
    (isRequestDay ? color : isExcludedDay ? "text.disabled" : "text.primary") ||
    "text.primary";
  const defaultBgColor = isRequestDay
    ? bgColor ?? "transparent"
    : "transparent";
  const defaultCursor = isRequestDay ? "pointer" : "default !important";

  const bleed = bleedByPosition[position];
  const borderRadius = isRequestDay
    ? borderRadiusByPosition[position]
    : "0.25rem";

  return {
    fontWeight: 700,
    bgcolor: "transparent",
    color: defaultColor,
    borderRadius: "0.25rem",
    cursor: defaultCursor,
    position: "relative",
    overflow: "visible",
    zIndex: 1,

    // Colored background layer — bleeds into adjacent 2px margins for multi-day requests
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      left: isRequestDay ? bleed.left : "0px",
      right: isRequestDay ? bleed.right : "0px",
      backgroundColor: defaultBgColor,
      borderRadius,
      zIndex: -1,
    },

    "&:hover, &:focus": {
      bgcolor: "transparent",
    },

    "&.Mui-selected": {
      bgcolor: "transparent",
      color: "text.primary",
      fontWeight: 400,

      "&:hover, &:focus": {
        bgcolor: "transparent",
      },
    },

    "&:not(.Mui-selected)": {
      borderColor: "primary.dark",
    },
  };
};

export const getPaperStyles = (theme: Theme) => ({
  maxWidth: "fit-content",
  margin: "0 auto",

  [theme.breakpoints.up("sm")]: {
    margin: "0",
  },
});

export const calendarDrawerStyles = {
  ".MuiDrawer-paper": {
    borderRadius: "26px 26px 0px 0px",
    padding: "2rem 1.5rem 2rem",
  },
};
